import React from "react";
import { useNavigate } from "react-router-dom";
import "./WelcomePage.css";
import backgroundImage from "../../assets/images/photobackground.png";
import logoImage from "../../assets/images/LogoImage.svg";

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleJoinAsCreator = () => {
    navigate("/join-creator");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  // Inline style for background image
  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
    <div className="welcome-container" style={containerStyle}>
      {/* Header */}
      <header className="welcome-header">
        <div className="logo-container">
          <img src={logoImage} alt="AstroCure" className="logo-image" />
        </div>
        <button className="login-btn-header" onClick={handleLogin}>
          Login
        </button>
      </header>

      {/* Main Content */}
      <main className="welcome-main">
        <div className="welcome-card">
          <div className="card-logo">
            <img src={logoImage} alt="AstroCure" className="card-logo-image" />
          </div>

          <h1 className="welcome-title">
            Welcome to <span className="brand-name">AstroCure</span>
          </h1>

          <p className="welcome-subtitle">Ahead of Time</p>

          <button className="btn-primary" onClick={handleJoinAsCreator}>
            Join as a Creator
          </button>

          <div className="divider">
            <div>OR</div>
          </div>

          <button className="btn-secondary" onClick={handleLogin}>
            Login
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="welcome-footer">
        <p className="copyright">© 2026 Astrovidhi Pvt Ltd</p>
        <div className="footer-links">
          <a href="/privacy-policy" className="footer-link">
            Privacy Policy
          </a>
          <a href="/terms-conditions" className="footer-link">
            Terms and Conditions
          </a>
        </div>
      </footer>
    </div>
  );
};

export default WelcomePage;
